import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Weingläser, Weine und Mini-Bottles bereitstellen. Dank des Gratis-Verkostungsschlucks im 50-ml-Fläschchen können Sie verkosten und Ihre Favoriten später genießen.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      